export function snakeCaseToNormal(str) {
    return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/(?:^|\s)\S/g, function (match) {
            return match.toUpperCase();
        });
}